import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import GButton from "components/ui/button/Button";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  createTimedEventCombos,
  getTagsInCombo,
  getTimedEventsCombos,
} from "../../services/timedEventsCombosService";

const AppliesOnCombosModal = ({ onClose }) => {
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { handleSubmit, setValue } = useForm();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });

  const toast2 = useToast({
    position: "top",
    duration: 3000,
    status: "error",
  });

  const combos = useSelector((state) => state.timedEventsCombos);

  useEffect(() => {
    dispatch(getTagsInCombo(id.id));
  }, [dispatch, id.id]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.timedEvents.edit_combo")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.Combos = values.Combos?.map((el) => ({
                ComboId: el.ComboId,
              }));
              values.TimedEventId = id.id;
              values.UserId = localStorage.getItem("userId");
              if (values.Combos === undefined || values.Combos?.length === 0) {
                toast2({
                  description: t("validation.required"),
                });
              } else {
                dispatch(createTimedEventCombos(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t(
                        "pages.timedEvents.combo_timed_event_created"
                      ),
                    });
                    dispatch(getTimedEventsCombos(id.id));
                    onClose();
                  });
              }
            })}
          >
            <Stack>
              <MultiSelect
                title={t("pages.combos.combos")}
                data={
                  Array.isArray(combos.tagsInCombo)
                    ? combos.tagsInCombo.map((el) => ({
                        ...el,
                        label: el.ComboName,
                        value: el.ComboId,
                      }))
                    : []
                }
                isMulti={true}
                isRequired={true}
                onChange={(e) => setValue("Combos", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("pages.inventory_item_details.apply")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={combos.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={combos.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default AppliesOnCombosModal;
